import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
export default function Modal({ open, title, onClose, children, actions }) {
  // ESC pour fermer
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[1500] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-[min(720px,92vw)] rounded-2xl bg-white shadow-xl border max-h-[calc(100svh-2rem)] overflow-hidden flex flex-col">
        <div className="px-5 py-4 border-b flex items-center justify-between">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            onClick={onClose}
            className="px-2 py-1 rounded hover:bg-slate-100"
            aria-label="Fermer"
          >
            ✕
          </button>
        </div>
        <div className="px-5 py-4 overflow-y-auto">{children}</div>
        <div className="px-5 py-3 border-t bg-white flex gap-2 justify-end">{actions}</div>
      </div>
    </div>,
    document.body,
  );
}
